export default {
  pageTitle: '巨屏抽奖',
  pageDesc: '从扫码入场到幸运揭晓，让每一位来宾成为现场的主角。',
  backToList: '返回活动列表',
  list: {
    description: '选择抽奖活动，管理现场抽奖、奖项规则、页面装修和参与记录。',
    create: '创建抽奖活动',
    count: '抽奖活动',
    search: '搜索活动名称',
    name: '活动名称',
    prizes: '奖项数量',
    prizeUnit: '项',
    participants: '参与人数',
    peopleUnit: '人',
    winners: '累计中奖',
    status: '状态',
    actions: '操作',
    enter: '进入活动',
    participantList: '参与名单',
    winnerList: '中奖名单',
    namePlaceholder: '请输入抽奖活动名称',
    nameRequired: '请填写抽奖活动名称',
    createTitle: '创建抽奖活动',
    createSuccess: '抽奖活动已创建',
    empty: '还没有抽奖活动，创建一个开始吧',
    active: '抽奖进行中',
    pending: '待开启',
    disabled: '已关闭',
    loadFailed: '抽奖活动列表加载失败'
  },
  createForm: {
    title: '主标题',
    subtitle: '副标题',
    titlePlaceholder: '例如：2026年度盛典幸运抽奖',
    subtitlePlaceholder: '例如：相聚此刻，好运与你同在',
    prizeConfig: '奖项配置',
    prizeConfigDesc: '按配置顺序抽奖；奖品图片推荐 1:1 透明 PNG，2 MB 以内。',
    prizeLevel: '奖项名称',
    giftName: '奖品名称',
    prizeImage: '奖品图片（1:1）',
    winnerSlots: '中奖名额',
    prizeLevelPlaceholder: '奖项名称',
    giftNamePlaceholder: '奖品名称',
    dragToSort: '按住上下拖动排序',
    uploadImage: '上传图片',
    removeImage: '移除图片',
    imageHint: '上传或更换奖品图片，推荐 1:1 透明 PNG',
    delete: '删除',
    addPrize: '添加奖项',
    createAndEnter: '创建并进入',
    titleRequired: '请填写主标题',
    prizeRequired: '请至少添加一个奖项',
    prizeFieldsRequired: '请完整填写奖项名称和奖品名称',
    imageTypeError: '仅支持 PNG、JPG 或 WebP 图片',
    imageSizeError: '单张奖品图片不能超过 2 MB',
    imageUploadFailed: '活动已创建，但部分奖品图片上传失败，请进入活动后重新配置',
    partialCreated: '活动已创建，但部分配置未保存成功，请进入活动后检查并补全',
    createFailed: '创建抽奖活动失败，请稍后重试',
    defaultLevel: '幸运奖',
    defaultGift: '会务专属礼盒',
    defaultSpecialLevel: '特别奖',
    defaultSpecialGift: '惊喜纪念礼品'
  },
  openParticipant: '打开参与页',
  openScreen: '打开抽奖大屏',
  copyScreenLink: '复制抽奖大屏链接',
  screenLinkCopied: '抽奖大屏链接已复制',
  screenLinkCopyFailed: '复制失败，请手动选择链接复制',
  reset: {
    activity: '重置活动',
    winners: '重置中奖人员',
    activityTitle: '确认重置并进入下一场',
    winnersTitle: '确认重置中奖人员',
    activityWarning: '将结束当前场次并开启下一场。历史参与名单与中奖记录会保留，内定奖项会清空；本场未中奖的微信授权参与者会自动进入下一场，未中奖且标记为“多轮”的导入参与者会进入下一场。',
    winnersWarning: '将清空当前场次的中奖记录，参与名单和奖项配置会保留。',
    captchaPlaceholder: '请输入验证码',
    refreshCaptcha: '点击刷新验证码',
    captchaRequired: '请输入图形验证码',
    captchaLoadFailed: '验证码加载失败，请重试',
    confirm: '确认重置',
    resetting: '重置中…',
    activitySuccess: '已进入下一场次',
    winnersSuccess: '中奖人员已重置',
    notReady: '所有奖项抽完后才能重置活动'
  },
  loading: '正在加载抽奖配置…',
  loadFailed: '抽奖配置加载失败',
  save: '保存配置',
  saving: '保存中…',
  saveSuccess: '巨屏抽奖配置已保存',
  tabs: {
    console: '控制台',
    prizes: '奖项与规则',
    design: '大屏装修',
    participants: '参与名单',
    winners: '中奖记录'
  },
  console: {
    title: '抽奖控制台',
    desc: '由后台人员统一控制抽奖轮次、开奖节奏和大屏二维码。',
    liveControl: '现场控制',
    screenPreview: '抽奖大屏实时预览',
    openParticipation: '开启参与',
    closeParticipation: '结束参与',
    scanJoin: '扫码参与抽奖',
    scanHint: '使用微信扫描二维码，授权后完成参与签到',
    roundPrize: '本轮奖项',
    winnerUnit: '位',
    notDrawn: '未抽奖',
    waiting: '等待中',
    operatorMode: '后台操作',
    currentRound: '当前轮次',
    noRound: '尚未开始',
    participants: '参与人数',
    readyForDraw: '位候选来宾',
    currentPrize: '当前奖项',
    prizePlaceholder: '选择本轮奖项',
    start: '开始抽奖',
    roll: '开始抽奖',
    finish: '停止并开奖',
    cancel: '取消本轮',
    controlHint: '控制结果会实时同步到抽奖大屏，请确认现场准备就绪后操作。',
    qrTitle: '大屏二维码',
    qrEnabled: '二维码显示中',
    qrDisabled: '二维码已关闭',
    qrEnabledHint: '嘉宾可以继续扫码登录参与抽奖。',
    qrDisabledHint: '大屏将隐藏参与二维码，改为显示中奖查询二维码；已参与名单不受影响。',
    qrShown: '大屏二维码已显示',
    qrHidden: '大屏二维码已关闭'
  },
  stats: {
    signed: '已签到',
    signedGuests: '已签到来宾',
    participants: '已参与',
    winners: '已中奖',
    cumulativeWinners: '累计中奖',
    unit: '人'
  },
  prizes: {
    fallbackLevel: '奖项 {index}',
    title: '奖项与中奖名额',
    desc: '按奖项配置顺序逐轮抽取，每轮按设定名额随机抽取；人数不足时仅抽取实际可参与人数。奖品图片推荐上传 1:1 透明 PNG，2 MB 以内。',
    enabled: '启用巨屏抽奖',
    level: '奖项名称',
    name: '奖品名称',
    image: '奖品图片（1:1）',
    quantity: '每轮中奖名额',
    fixedWinner: '内定中奖',
    fixedWinnerMobile: '在参与名单中设置',
    actions: '操作',
    levelPlaceholder: '如：幸运奖',
    namePlaceholder: '如：会务专属礼盒',
    add: '添加奖项',
    delete: '删除',
    dragToSort: '按住上下拖动排序',
    uploadImage: '上传图片',
    removeImage: '移除图片',
    imageHint: '上传或更换奖品图片，推荐 1:1 透明 PNG',
    imageTypeError: '仅支持 PNG、JPG 或 WebP 图片',
    imageSizeError: '单张奖品图片不能超过 2 MB',
    imageUploadFailed: '奖品图片上传失败，请重试',
    noRepeatHint: '同一来宾在本次活动中仅可中奖一次，已中奖者会自动排除。',
    empty: '尚未添加奖项，请先添加奖项和奖品。',
    completePrize: '请完整填写奖项名称、奖品名称和中奖名额',
    fixedWinnerOverLimit: '“{name}”最多只能内定 {count} 人，请减少内定人数或提高中奖名额',
    deleteConfirm: '确认删除“{name}”奖项吗？已产生的中奖记录不会丢失。',
    participationDuration: '参与时长（秒）',
    participationDurationHint: '默认 180 秒，即 3 分钟；扫码后需在倒计时内参与。',
    rollDuration: '滚动抽奖时长（秒）',
    rollDurationHint: '参与结束后自动开始滚动，并在设定时长后揭晓结果。',
    repeatWinner: '允许同一来宾跨轮次重复中奖',
    screenTitle: '大屏标题',
    screenSubtitle: '大屏副标题',
    screenSettings: '大屏展示',
    theme: '大屏主题',
    themes: {
      gold: '鎏金之夜',
      red: '中国红',
      blue: '科技蓝'
    },
    currentRound: '当前轮次',
    noRound: '尚未开始抽奖',
    nextPrize: '待抽取奖品',
    startRound: '开始本轮',
    rollNow: '立即开奖',
    finishNow: '提前揭晓',
    cancelRound: '取消本轮',
    status: {
      joining: '参与中',
      rolling: '滚动中',
      finished: '已开奖',
      cancelled: '已取消'
    }
  },
  design: {
    title: '大屏页面装修',
    mainTitle: '主标题',
    mainTitlePlaceholder: '请输入大屏主标题',
    subtitle: '副标题',
    subtitlePlaceholder: '请输入大屏副标题',
    stageBackground: '舞台背景装修',
    stageBackgroundHint: '选择内置背景或上传自定义图片，背景自动铺满大屏，建议将重要画面放在四周。',
    backgrounds: {
      gold: { name: '星耀鎏金', desc: '金色光束 · 年会盛典' },
      red: { name: '鸿运红幕', desc: '红绸金线 · 喜庆抽奖' },
      blue: { name: '星河极光', desc: '蓝色光环 · 科技盛会' }
    },
    customBackground: '自定义背景',
    customBackgroundHint: 'JPG / PNG / WebP，5 MB 以内，建议 1920 × 1080，上传后保存到云端',
    uploadBackground: '上传背景',
    logo: '活动 Logo',
    uploadImage: '上传图片',
    remove: '移除',
    logoHint: '最大 5 MB，支持透明 PNG',
    uploadedImage: '已上传图片',
    backgroundMusic: '背景音乐',
    backgroundMusicHint: '支持 MP3 / WAV / OGG，10 MB 以内；未上传或移除后默认使用系统背景音乐。',
    defaultMusic: '默认背景音乐',
    uploadMusic: '上传音乐',
    musicTypeError: '仅支持 MP3、WAV 或 OGG 音频',
    musicSizeError: '音频文件不能超过 10 MB',
    joinCopy: '签到成功页文案',
    successText: '成功提示',
    blessing: '祝福话语',
    sound: '启用背景音乐与抽奖音效（在大屏中点击开启声音）',
    autoReturn: '中奖后自动返回抽奖首页',
    autoReturnHint: '关闭后大屏不显示自动返回倒计时，但仍可点击“返回抽奖首页”。',
    autoReturnSeconds: '自动返回时间（秒）',
    autoReturnSecondsSuffix: '秒后返回首页',
    autoReturnSecondsPlaceholder: '请输入 1-3600 秒',
    autoReturnSecondsInvalid: '自动返回时间需在 1-3600 秒之间',
    effectHint: '动效：参与者逐个入场、3D 旋转或矩阵滚动、开奖聚光与彩屑。减少动态效果的设备自动简化动画。',
    save: '保存装修',
    saving: '保存中…',
    saveSuccess: '大屏装修已保存',
    saveFailed: '大屏装修保存失败，请稍后重试',
    titleRequired: '请填写主标题',
    titlePlaceholder: '你的大屏主标题',
    previewPrizeName: '幸运奖 · 会务专属礼盒',
    imageTypeError: '仅支持 JPG、PNG 或 WebP 图片',
    backgroundSizeError: '背景图片不能超过 5 MB',
    logoSizeError: '活动 Logo 不能超过 5 MB',
    previewTitle: '页面效果预览',
    previews: {
      screen: '抽奖大屏',
      join: '签到页面',
      success: '参与成功'
    },
    sampleNumber: 'A001',
    sampleName: '王小美',
    previewEmpty: '暂无可预览的页面',
    openPreview: '打开抽奖大屏预览',
    openJoinPreview: '打开签到页面预览',
    openSuccessPreview: '打开参与成功预览',
    previewHint: '点击后在新窗口打开对应页面。'
  },
  participants: {
    title: '参与名单',
    desc: '嘉宾扫码完成授权登录即可参与抽奖，不依赖签到名单。',
    search: '搜索姓名 / 手机号 / 昵称 / 抽奖编号',
    name: '姓名',
    lotteryNumber: '抽奖编号',
    mobile: '手机号',
    fixedWinner: '内定奖项',
    fixedWinnerPlaceholder: '选择该手机号内定的奖项',
    organization: '单位',
    session: '场次',
    source: '来源',
    sourceWechat: '微信授权',
    sourceImport: '导入',
    multiRound: '参与场次',
    onlyOneRound: '仅1轮抽奖',
    multiRoundOption: '多轮抽奖',
    allSessions: '全部场次',
    allSources: '全部来源',
    multiRoundUpdateFailed: '参与场次设置失败',
    round: '参与轮次',
    joinedAt: '参与时间',
    actions: '操作',
    delete: '删除',
    deleteConfirm: '确认删除“{name}”吗？删除后该人员将从当前参与名单中移除。',
    deleteSuccess: '参与人员已删除',
    deleteFailed: '删除参与人员失败',
    empty: '暂无参与记录，打开参与页并完成登录后会显示在这里。',
    total: '共 {count} 人',
    downloadTemplate: '下载导入模板',
    importCsv: '导入 CSV 名单',
    importHint: 'CSV 首行为表头，需包含“姓名”和“手机号”列；姓名、手机号必填。相同手机号会覆盖已有名单中的姓名。',
    csvMalformed: 'CSV 文件格式错误',
    csvHeaderError: 'CSV 表头需包含姓名和手机号（或手机号码）',
    csvRowError: '第 {row} 行姓名为空或手机号格式不正确',
    importResult: '导入完成：新增 {created} 人，覆盖 {updated} 人'
  },
  winners: {
    title: '中奖记录',
    export: '导出记录',
    session: '场次',
    roundPrize: '奖项',
    prize: '奖品',
    winner: '中奖人',
    lotteryNumber: '抽奖编号',
    mobile: '手机号',
    drawnAt: '开奖时间',
    claimStatus: '领奖状态',
    claimedAt: '领取时间',
    claimed: '已领取',
    markClaimed: '标记已领取',
    cancelClaimed: '撤销领取',
    empty: '暂无中奖记录',
    total: '共 {count} 条',
    exportHeaders: {
      session: '场次',
      round: '轮次',
      prizeLevel: '奖项',
      prizeName: '奖品',
      winner: '中奖人',
      lotteryNumber: '抽奖编号',
      mobile: '手机号',
      drawnAt: '开奖时间',
      claimed: '领奖状态',
      claimedAt: '领取时间'
    }
  },
  confirm: {
    startTitle: '开始新一轮抽奖',
    startMessage: '确认开始“{prize}”抽奖吗？参与通道将持续开放，直到点击“立即开奖”。',
    finishTitle: '提前揭晓',
    finishMessage: '确认立即结束滚动并生成本轮中奖名单吗？',
    cancelTitle: '取消本轮',
    cancelMessage: '取消后本轮参与记录会保留，但不会产生中奖者。确认取消吗？'
  },
  join: {
    title: '扫码参与抽奖',
    desc: '现场大屏滚动，幸运可能随时降临。',
    tagWelcome: '欢迎参与幸运时刻',
    tagHeadline: '今夜，好运属于你',
    wechatLoginTitle: '微信授权登录',
    wechatLoginIntro: '授权后，即可参与本次幸运抽奖',
    wechatPermissionTitle: '使用微信昵称作为参与者名称',
    wechatPermissionHint: '授权成功后自动生成专属参与编号',
    wechatButton: '微信授权参与',
    wechatUnavailable: '当前公众号授权未配置，请联系现场工作人员',
    mobileTitle: '完善手机号',
    mobileIntro: '微信授权成功，请填写手机号完成参与',
    mobileLabel: '手机号',
    mobileHint: '仅校验手机号格式，无需短信验证码',
    mobileFormatError: '请输入正确的11位手机号',
    loginExpired: '登录已过期，请重新扫码进入',
    bindingMobile: '正在绑定…',
    finishJoin: '完成绑定并参与',
    mobileBindFailed: '手机号绑定失败，请重试',
    successNumberLabel: '参与编号',
    successTitle: '参与成功',
    successMessage: '你已加入幸运名单，请留意现场大屏',
    blessing: '愿你心有所期，所遇皆是好运',
    loading: '正在连接抽奖现场…',
    wechatLogin: '微信登录并参与',
    loggingIn: '正在登录…',
    loginHint: '将在微信内获取头像和昵称，仅用于现场抽奖展示。',
    identityTitle: '补充参与身份',
    identityDesc: '请输入参与抽奖使用的姓名和手机号。',
    name: '姓名',
    namePlaceholder: '请输入姓名',
    mobile: '手机号',
    mobilePlaceholder: '请输入11位手机号',
    verify: '验证并进入',
    verifying: '正在验证…',
    manualTitle: '本机演示登录',
    manualHint: '当前环境未启用公众号授权，可使用姓名和手机号参与。',
    manualNickname: '展示昵称（选填）',
    welcome: '你好，{name}',
    myNumber: '我的抽奖编号',
    numberHint: '请记住该编号，后续每一轮将自动参与',
    checkinRequired: '登录失败，请重新扫码进入。',
    autoJoined: '已自动进入本轮奖池',
    waitTitle: '等待主持人开始',
    waitDesc: '保持页面打开，新一轮抽奖开始后即可参与。',
    joinTitle: '本轮抽奖开放中',
    joinDesc: '点击参与后，你的头像会出现在现场大屏。',
    joinButton: '立即参与',
    joining: '正在参与…',
    joined: '已参与，请留意大屏',
    countdown: '剩余 {seconds} 秒',
    closed: '本轮参与已结束',
    rolling: '抽奖正在滚动，请盯紧大屏',
    winner: '恭喜中奖！',
    notWinner: '本轮暂未中奖，下一轮继续加油',
    noRound: '新一轮抽奖尚未开始',
    disabled: '抽奖活动暂未开放',
    notWechat: '请使用微信扫描现场大屏二维码参与',
    reload: '刷新状态',
    error: '暂时无法连接抽奖现场，请稍后重试'
  },
  winnerQuery: {
    eyebrow: '幸运时刻 · 中奖查询',
    title: '查询中奖情况',
    subtitle: '输入手机号查询全部场次中奖结果',
    queryTitle: '输入手机号查询',
    queryIntro: '请输入参与抽奖时使用的手机号，查看全部场次中奖记录',
    mobileLabel: '手机号',
    mobilePlaceholder: '请输入11位手机号',
    mobileHint: '无需微信授权，仅用于匹配全部场次的参与和中奖记录',
    mobileFormatError: '请输入正确的11位手机号',
    mobileQueryButton: '查询中奖记录',
    mobileQuerying: '正在查询…',
    mobileQueryFailed: '手机号查询失败，请稍后重试',
    participant: '查询人',
    lotteryNumber: '参与编号',
    congratulations: '恭喜你',
    winnerSummary: '共中奖 {count} 次',
    sessionRound: '第 {session} 场 · 第 {round} 轮',
    claimed: '已领取',
    notClaimed: '待领取',
    noWinTitle: '暂未查询到中奖记录',
    noWinDesc: '暂未查询到中奖记录，请以现场大屏公布结果为准。',
    refreshing: '正在刷新…',
    refresh: '刷新结果',
    queryAnother: '查询其他手机号',
    disclaimer: '查询结果仅供参考，最终以现场开奖记录为准'
  },
  screen: {
    eyebrow: '幸运抽奖现场',
    waiting: '等待开启新一轮',
    waitingHint: '嘉宾可提前扫码登录，主持人开始后即可参与',
    scanTitle: '扫码参与抽奖',
    scanHint: '微信扫码登录，头像与昵称将展示在现场大屏',
    participantCount: '{count} 位来宾已参与',
    countdownUnit: '秒后结束参与',
    joinedTitle: '参与抽奖的来宾',
    allGuests: '所有已参与来宾',
    noParticipants: '等待嘉宾扫码参与',
    noEligibleWinners: '本轮没有符合条件的中奖嘉宾',
    choosePrize: '选择下一轮奖项',
    rolling: '幸运正在发生',
    rollingHint: '请屏息以待，幸运即将揭晓',
    winners: '本轮幸运来宾',
    nextPrize: '下一份奖品',
    remaining: '剩余 {count} 份',
    winnersPerRound: '每轮 {count} 名',
    roundNo: '第 {round} 轮',
    start: '开始本轮',
    roll: '立即开奖',
    finish: '提前揭晓',
    cancel: '取消本轮',
    soundOn: '声音已开启',
    soundOff: '声音已关闭',
    tapToEnableSound: '点击开启声音',
    returnHomeIn: '{seconds} 秒后自动返回抽奖首页 · 点击立即返回',
    returnHome: '返回抽奖首页',
    adminOnly: '大屏控制',
    fullscreen: '全屏',
    error: '大屏状态加载失败',
    retry: '重新连接',
    idlePrize: '奖品准备中',
    winnerQueryEyebrow: '中奖结果查询',
    winnerQueryTitle: '扫码查询中奖情况',
    winnerQueryHint: '输入参与手机号即可查询全部场次中奖记录'
  }
}
